const container = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: 'linear-gradient(0deg, rgba(24,14,29,1) 0%, rgba(59,34,71,1) 100%)',
    backgroundRepeat: 'noRepeat',
    backgroundAttachment: 'fixed',
    height: '100vh'
  }

const iframeStyle = {
    /* Sizing and Centering */
    display: 'block', /* Makes margin:auto work */
    width: '100%',
    maxWidth: '1200px', /* Prevents it from being huge on big screens */
    margin: '20px auto', /* Centers the iframe on the page */

    /* The Magic Property */
    aspectRatio: '16 / 9',

    /* Your Optional Border */
    border: '2px solid white',
    overflow: 'hidden'
}

export default function AnivPage () {
  return (
    <div style={container}>
      <h1 style={{ color: 'white' }}>A little something I made for you... Click on the stars below!</h1>
      <p style={{ color: 'white' }}>I want to apologize firstly, I feel like I can express myself much better in English, and while I'll try to put in Spanish when I can, the majority will be English, for my sake..</p>
    <iframe
        src="/ATAN/index.html"
        title="Happy Anniversary"
        style={iframeStyle}
    />
    </div>
  );
}